import React, {useRef} from 'react'
import bem from '../../helpers/bem'
import './style.scss'
import Card from '../card'
import {useOuterClick} from '../../hooks/common';
import {RESULT_NOTIFICATION_INFO} from '../../constants/translations';
import {getCardKey} from '../../helpers/card';

const ResultNotification = ({
                              winner: {
                                name,
                                combination,
                                cards,
                              },
                              clickOutside,
                            }) => {
  const block = 'notification';
  const cardsBlock = useRef(null);
  useOuterClick(
    clickOutside || false,
    cardsBlock
  );

  return (
    <div className={block}>
      <div className={bem({block, elem: 'info-wrapper'})}>
        <div className={bem({block, elem: 'title'})}>
          {name}
        </div>
        <div className={bem({block, elem: 'combination'})}>
          {combination}
        </div>
      </div>
      <div className={bem({block, elem: 'cards-wrapper'})}>
        <div className={bem({block, elem: 'cards-info'})}>
          {RESULT_NOTIFICATION_INFO}
        </div>
        <div
          ref={cardsBlock}
          className={bem({block, elem: 'cards'})}
        >
          {cards && cards.map((card, index) => card &&
            <Card
              rank={card.rank}
              suit={card.suit}
              key={getCardKey(index, card)}
              result
            />
          )}
        </div>
      </div>
    </div>
  )};

export default ResultNotification;